import { icons as LucideIcons } from "lucide-react";
import React, { memo } from "react";
import { AnimatePresence, motion } from "framer-motion";

type Props = {
	checked?: boolean;
	disabled?: boolean;
	onCheck?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

function Checkbox({ checked, onCheck, disabled }: Props) {
	const CheckIcon = LucideIcons["Check"];
	return (
		<button
			onClick={onCheck}
			disabled={disabled}
			style={{
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				background: "none",
				border: "none",
				height: 16,
				width: 16,
				minWidth: 16,
				padding: 0,
				cursor: disabled ? "not-allowed" : "pointer",
			}}
		>
			<motion.div
				style={{
					height: 16,
					width: 16,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					borderRadius: 4,
					borderWidth: 2,
					borderStyle: "solid",
					opacity: disabled ? 0.6 : 1,
				}}
				initial={{
					scale: 1,
					opacity: 1,
					borderColor: "#C4C4C4",
					backgroundColor: "#fff",
				}}
				animate={{
					borderColor: checked ? "#0946B8" : "#C4C4C4",
					backgroundColor: checked ? "#0946B8" : "#fff",
					scale: checked ? 1.1 : 1,
					opacity: checked ? 1 : 0.8,
				}}
				transition={{ duration: 0.2 }}
			>
				{checked && (
					<motion.div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
						initial={{ scale: 0 }}
						animate={{ scale: 1 }}
						exit={{ scale: 0 }}
						transition={{ duration: 0.2 }}
					>
						<CheckIcon
							size={14}
							color={checked ? "#fff" : "#C4C4C4"}
							strokeWidth={5}
						/>
					</motion.div>
				)}
			</motion.div>
		</button>
	);
}

export default memo(Checkbox);
